import React from "react";
import Frame from "../assets/graphics/Photo Frame.svg";
import styled from "styled-components";
import { SectionTitle } from "../styles/CommonStyles";
import { Button } from "rsuite";
import HTMLParser from "./Parser";

const PhotoFrame = ({
  src,
  onClick,
  title,
  content,
  btnTitle,
  type = "main",
  width,
  frame = "photo",
}) => {
  return (
    <CardContainer style={{ width: width }}>
      <Overlay src={Frame} />
      <PictureContainer>
        {frame == "photo" ? <Picture src={src} /> : <Video src={src} />}
      </PictureContainer>
      <TextContainer>
        {type == "main" ? (
          <Section
            style={{
              alignItems: content ? "flex-start" : "center",
              justifyContent: content ? "space-between" : "center",
              gap: 10,
              padding: 15,
            }}
          >
            <SectionTitle>{title}</SectionTitle>
            <BTN onClick={onClick}>{btnTitle}</BTN>
          </Section>
        ) : (
          <Section style={{ alignItems: "flex-start", padding: 14 }}>
            <CardTitle>{title}</CardTitle>
            <CardSubtitle>
              <HTMLParser html={content} type="card" />
            </CardSubtitle>
            <BTN onClick={onClick}>Learn More...</BTN>
          </Section>
        )}
      </TextContainer>
    </CardContainer>
  );
};

export default PhotoFrame;

const CardContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 200px;
  border-radius: 2px;
  overflow: hidden;

  @media (min-width: 1280px) {
    width: 48%;
  }
  @media (max-width: 768px) {
    height: 150px;
  }
`;

const Overlay = styled.img`
  position: absolute;
  right: 0;
  object-fit: cover;
  width: 80%;
  height: 100%;
  border-radius: 2px;
  z-index: 2;
`;

const PictureContainer = styled.div`
  position: relative;
  flex-basis: 50%;
  background-color: teal;
  z-index: 1;
`;

const Picture = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 200ms ease-in-out;
  cursor: pointer;
  &:hover {
    scale: 1.2;
  }
`;

const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const TextContainer = styled.div`
  flex-basis: 50%;
  background-color: #fcfbff;
  z-index: 3;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: #fbfbff;
  height: 100%;
  flex-basis: 50%;
  /* gap: 10px; */

  @media (max-width: 768px) {
    flex-basis: 100%;
  }
`;

let BTN = styled(Button)`
  background-color: transparent;
  border-radius: 3px;
  box-sizing: border-box;
  border: 1px solid #c6c662;
  width: 100%;
  &:hover {
    background-color: #fff;
    border: 1px solid #c6c662;
    color: #c6c662;
  }
  @media (max-width: 768px) {
    width: 100px;
    height: 30px;
    font-size: 1.2rem;
    line-height: 0px;
  }
`;

const CardTitle = styled.p`
  font-family: "Poppins", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 1rem;
  color: #c6c661;
  font-weight: 600;
  text-align: left;
  /* margin-top: 30px; */
  color: #252528;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: 1rem;
    line-height: 25px;
    margin-top: 0px;
  }
`;

const CardSubtitle = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* height: 50%; */
  overflow: hidden;
  @media (max-width: 768px) {
    font-size: 1.2rem;
    line-height: 25px;
  }
`;
